import { useEffect, useState } from "react";
import {} from "../../../Models/ParcelTemplate.ts";
// import { ErrorResponse } from "../../../Models/Error.ts";
import { callErrorToast } from "../../../utilities/utilities.ts";
import { AttachmentsService } from "../../../services/registry/attachments.ts";
import { Attachment } from "../../../Models/Attachment.ts";
import { defaultFetchParam } from "../../../Models/FetchParam.ts";
import { createModalConfig, ModalConfig } from "../../../Models/ModalConfig.ts";
import {
  AttachmentsIndexContextValue,
  AttachmentsIndexProviderProps,
} from "./types.ts";
import { AttachmentsIndexContext } from "./contexts.ts";

const attachmentsService = new AttachmentsService();

export const AttachmentIndexProvider: React.FC<
  AttachmentsIndexProviderProps
> = ({ id, children, callback }) => {
  const [data, setData] = useState<Partial<Attachment[]>>([]);
  const [loader, setLoader] = useState<boolean>(true);

  const [modalConfig, setModalConfig] =
    useState<ModalConfig>(createModalConfig());

  const getAttachment = async (id: string) => {
    setLoader(true);
    try {
      const res = await attachmentsService.all({
        ...defaultFetchParam,
        search: [
          {
            selector: "shipmentId",
            value: id,
            precise: true,
          },
        ],
      });
      setData(res.data.content || []);
      return res;
    } catch (err) {
      callErrorToast(err);
      throw err;
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (id) {
      getAttachment(id);
      return;
    }
    setLoader(false);
  }, [id]);

  const contextValue: AttachmentsIndexContextValue = {
    data,
    loader,
    modalConfig,
    setModalConfig,
    callback,
  };
  return (
    <AttachmentsIndexContext.Provider value={contextValue}>
      {children}
    </AttachmentsIndexContext.Provider>
  );
};
